import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

/**
 * Läser streckkoder från en HID-skanner, dvs en skanner (USB eller Bluetooth) som
 * beter sig som ett tangentbord mot mobilen/datorn.
 *
 * Skannern "skriver" tecknen mycket snabbare än en människa och avslutar oftast med
 * Enter eller Tab. Tecknen buffras här och skickas vidare som en komplett streckkod
 * när avslutstecknet kommer, eller när det blivit tyst tillräckligt länge (för
 * skannrar som inte skickar något avslutstecken).
 */
@Injectable({
  providedIn: "root",
})
export class HardwareScannerService {
  /** Max tid mellan två tecken för att de ska tillhöra samma skanning (ms) */
  MAX_KEY_INTERVAL = 120;
  /** Tid utan nya tecken innan bufferten skickas iväg (ms) */
  END_OF_SCAN_DELAY = 150;
  /** Kortare än så här räknas inte som en streckkod */
  MIN_LENGTH = 4;

  private scanned = new Subject<string>();
  private buffer: string = "";
  private lastKeyTime: number = 0;
  private flushTimer: any = null;

  /** Emittar en komplett streckkod varje gång skannern har läst av en. */
  get barcodeScanned$(): Observable<string> {
    return this.scanned.asObservable();
  }

  constructor() {
    //Capture så att koden fångas innan t.ex. en fokuserad knapp hinner reagera
    document.addEventListener("keydown", (ev) => this.OnKeyDown(ev), true);
  }

  private OnKeyDown(ev: KeyboardEvent) {
    if (ev.ctrlKey || ev.metaKey || ev.altKey) return;
    if (this.IsTypingInField(ev.target)) return;
    if (!ev.key) return;

    var now = new Date().getTime();
    //För långt mellan tecknen - det här är början på en ny skanning
    if (now - this.lastKeyTime > this.MAX_KEY_INTERVAL) {
      this.buffer = "";
    }
    this.lastKeyTime = now;

    if (ev.key == "Enter" || ev.key == "Tab") {
      if (this.buffer.length >= this.MIN_LENGTH) {
        //Enter från skannern får inte trigga knappen som råkar ha fokus
        ev.preventDefault();
        ev.stopPropagation();
      }
      this.Flush();
      return;
    }

    //Bara skrivbara tecken, dvs inte Shift, F5, piltangenter osv
    if (ev.key.length != 1) return;

    this.buffer += ev.key;
    this.ScheduleFlush();
  }

  private ScheduleFlush() {
    if (this.flushTimer) clearTimeout(this.flushTimer);
    this.flushTimer = setTimeout(() => this.Flush(), this.END_OF_SCAN_DELAY);
  }

  private Flush() {
    if (this.flushTimer) {
      clearTimeout(this.flushTimer);
      this.flushTimer = null;
    }

    var bc = this.buffer.trim();
    this.buffer = "";

    if (bc.length < this.MIN_LENGTH) return;

    console.log("HID-skanning:" + bc);
    this.scanned.next(bc);
  }

  private IsTypingInField(target: any): boolean {
    if (!target || !target.tagName) return false;

    var tag = target.tagName.toUpperCase();
    if (
      tag == "INPUT" || tag == "TEXTAREA" || tag == "SELECT" ||
      tag == "ION-INPUT" || tag == "ION-TEXTAREA" || tag == "ION-SEARCHBAR"
    ) {
      return true;
    }

    return target.isContentEditable === true;
  }
}
